import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=165d8564&scoped=true&"
import script from "./knowledge.vue?vue&type=script&lang=js&"
export * from "./knowledge.vue?vue&type=script&lang=js&"
import style0 from "./knowledge.vue?vue&type=style&index=0&id=165d8564&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165d8564",
  null
  
)

export default component.exports